import { GzContentControlApplicationRulesFormWebComponent } from './component/GzContentControlApplicationRulesFormWebComponent';

export { GzContentControlApplicationRulesFormWebComponent };
